var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOrangeCurveArrow = function SvgOrangeCurveArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 164,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.537 2.683C13.752 28.008 25.172 41.261 49.025 48.82c21.54 6.826 49.277 2.908 72.388 1.153 28.612-2.172 79.668 7.023 80.011 48.65.266 32.321-28.944 59.761-51.312 40.783-8.623-7.317-7.405-26.043 1.426-36.003 9.539-10.757 26.091-11.405 37.048-10.562 29.426 2.263 35.192 40.219 57.06 54.803 20.43 13.625 41.845 7.296 65.28-3.362 2.007-.913-2.435 8.546-3.36 10.982-3.39 8.931-.469 5.505 2.095-1.248 1.648-4.343 6.969-12.887 1.385-12.185-4.028.507-11.228-1.766-14.991-3.194",
    stroke: "#CBB915",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
};

export default SvgOrangeCurveArrow;